import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import AdminNavBar from "../../pages/Admin/NavBar/AdminNavBar";
import style from './ProjectFullView.module.css'
import BreadCrumb from "../BreadCrumb/BreadCrumb";

export default function ProjectFullView() {
    const { projectId, employeeId } = useParams();
    const [project, setProject] = useState({});
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    const apiurl = process.env.REACT_APP_SERVER_URL;
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    useEffect(() => {
        fetch(`${apiurl}/projects/${projectId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setLoading(false);
                setProject(data.projects)
            })
            .catch((err) => {
                setError(err.message);
                setLoading(true)
            });
    }, [projectId, apiurl]);

    const handleDelete = async () => {
        if (window.confirm("Are you sure you want to delete this project?")) {
            try {
                const response = await fetch(`${apiurl}/projects/${projectId}`, {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                });
                if (response.ok) {
                    alert("Project deleted successfully");
                    navigate(`/admin-dashboard/${employeeId}/all-projects`);
                } else {
                    const result = await response.json();
                    alert(result.message || "Failed to delete project");
                }
            } catch (err) {
                alert(err.message);
            }
        }
    };

    return (
        <>
            <div className="container pt-lg-2">
                <AdminNavBar />
                <div className="mb-3 ps-3">
                    <BreadCrumb
                        link={`/admin-dashboard/${employeeId}`}
                        name="Dashboard"
                        icon={true}
                    />
                    <BreadCrumb
                        link={`/admin-dashboard/${employeeId}/all-projects`}
                        name="All Projects"
                        icon={true}
                    />
                    <BreadCrumb
                        link={`/admin-dashboard/${employeeId}/projects/${projectId}`}
                        name={project.title}
                        icon={false}
                    />
                </div>
                <div className={style.fullView}>
                    <div className="card p-4  shadow mb-5">
                        {error && <p className="text-danger text-center">{error}</p>}

                        {/* <h3 className="mb-3 ps-4 text-center fw-bold">{project.title} Info</h3> */}
                        <table className="table  table-hover table-striped">
                            {
                                loading ?
                                    <>
                                        <tbody>
                                            {Array.from({ length: 10 }).map((_, idx) => {
                                                return (
                                                    <>
                                                        <tr key={idx} >
                                                            <td className=" text-center">
                                                                <span className="w-25 placeholder placeholder-xs"></span>
                                                            </td>
                                                            <td className=" text-center">
                                                                <span className="w-25 placeholder placeholder-xs"></span>
                                                            </td>

                                                        </tr>

                                                    </>
                                                )
                                            })}
                                        </tbody>
                                    </>
                                    :
                                    <>
                                        <thead>
                                            <tr>
                                                <td colSpan={2} className="text-center">
                                                    <h6> <b>{project.title}  </b> Full Details</h6>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            <tr>
                                                <td className="ps-4" style={{ width: '50%' }}>Title</td>
                                                <td className="ps-4">{project.title}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Client Name</td>
                                                <td className="ps-4">{project.client}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Client email</td>
                                                <td className="ps-4">{project.clientEmail}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Description</td>
                                                <td className="ps-4"> {project.description}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Platform</td>
                                                <td className="ps-4"> {project.platform}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Team</td>
                                                <td className="ps-4">{project.team}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Type</td>
                                                <td className="ps-4">{project.type}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">status</td>
                                                <td className="ps-4">{project.status}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Priority</td>
                                                <td className="ps-4">{project.priority}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Project Completion</td>
                                                <td className="ps-4">{project.progress} %</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Assigned employees</td>
                                                <td className="ps-4">{Array.isArray(project.employeeId) && project.employeeId.join(', ')}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Manager</td>
                                                <td className="ps-4">{project.manager}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Created By</td>
                                                <td className="ps-4">{project.createdBy}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Start Date</td>
                                                <td className="ps-4">{new Date(project.startDate).toLocaleDateString()}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">End Date</td>
                                                <td className="ps-4">{new Date(project.endDate).toLocaleDateString()}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">deadLine</td>
                                                <td className="ps-4">{new Date(project.deadLine).toLocaleDateString()}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Budget</td>
                                                <td className="ps-4">{project ? Number(project.budget).toLocaleString('en-IN') : 'pending'}</td>

                                            </tr>

                                            <tr>
                                                <td className="ps-4">Spend</td>
                                                <td className="ps-4"> {project
                                                    ? Number(project.spent).toLocaleString("en-IN")
                                                    : "Pending"}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Pending</td>
                                                <td className="ps-4"> {project
                                                    ? Number(project.pending).toLocaleString("en-IN")
                                                    : "Pending"}</td>
                                            </tr>

                                            <tr>
                                                <td className="ps-4">Created At:</td>
                                                <td className="ps-4">{new Date(project.createdAt).toLocaleDateString()}</td>
                                            </tr>
                                            <tr>
                                                <td className="ps-4">Last Updated</td>
                                                <td className="ps-4">{new Date(project.updatedAt).toLocaleDateString()}</td>
                                            </tr>

                                            <tr>
                                                <td className="ps-4 text-center"  >
                                                    <button
                                                        className="btn btn-warning"
                                                    >
                                                        <Link to={`/admin-dashboard/${employeeId}/update-project/${projectId}`} style={{ color: 'none', textDecoration: 'none' }}>
                                                            update
                                                        </Link>
                                                    </button>
                                                </td>

                                                <td className="ps-4  text-center"  >
                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={handleDelete}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </>
                            }
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

